import * as React from "react";

function SvgUndrawPersonalFinanceTqcd(props: any) {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="784.39764"
      height="733.6066"
      viewBox="0 0 784.398 733.607"
      {...props}
    >
      <path
        d="M624.745 521.218s97.04 5.017 74.437 35.565-81.994-17.92-81.994-17.92z"
        fill="#ffb8b8"
      />
      <path
        d="M445.916 230.251l19.752 4.938s11.522 34.567 19.752 65.84 24.69 125.097 24.69 125.097l127.61 89.433-15.22 34.048-170-67-37.859-148.657z"
        fill="#575a89"
      />
      <path opacity={0.2} d="M464.5 291.607l-7.362 154.165 15.362 45.835-45-33 37-167z" />
      <path
        d="M491.18 565.214s21.399 57.61 24.69 97.114 6.585 70.779 6.585 70.779H422.048l-19.752-29.629v29.629H285.43s-32.92-106.99-19.752-120.159 138.264-69.132 138.264-69.132z"
        fill="#2f2e41"
      />
      <path fill="#3f3d56" d="M101.5 731.607h581v2h-581z" />
      <circle cx={365.261} cy={105.155} r={62.548} fill="#ffb8b8" />
      <path
        d="M317.527 131.491l-4.938 72.424 62.548 83.947 31.274-79.009s-27.982-18.106-11.522-55.964z"
        fill="#ffb8b8"
      />
      <path
        d="M500.23 579.203c0 14.82-41.15 37.86-41.15 37.86v8.23l-16.46 8.23-36.21-72.42-9.87 79s-72.43 11.53-95.47 0c-23.05-11.52-34.57-6.58-67.49-18.1s13.17-166.25 13.17-166.25l-32.92-238.67 71.92-35.96 3.79-1.9 9.89-1.82 15.16-2.8 50.67 34.25 4.08 21.4 2.51 13.17 13.16-14.82 9.94-32.69 70.72 39.28-19.75 158.01s54.31 171.19 54.31 186z"
        fill="#575a89"
      />
      <path
        d="M258.27 630.231s75.717 60.902 39.505 72.424-55.964-62.548-55.964-62.548z"
        fill="#ffb8b8"
      />
      <path
        d="M230.289 220.375l-16.46-3.292s-24.69 13.168-26.337 39.505-23.044 210.688-23.044 210.688l69.133 186 55.964-21.399L235.227 457.4l41.15-151.432z"
        fill="#575a89"
      />
      <circle cx={372.5} cy={264.607} r={6} fill="#2f2e41" />
      <circle cx={372.5} cy={303.607} r={6} fill="#2f2e41" />
      <circle cx={406.5} cy={560.607} r={6} fill="#2f2e41" />
      <path
        d="M312.452 41.077l-11.562-4.629s24.176-26.616 57.812-24.302l-9.46-10.415s23.125-9.258 44.147 15.044c11.051 12.775 23.838 27.791 31.808 44.707h12.383l-5.168 11.38L450.5 84.24l-18.566-2.044a63.589 63.589 0 01.504 18.874 24.421 24.421 0 01-8.943 15.976s-14.34-29.68-14.34-34.31V94.31s-11.562-10.415-11.562-17.358l-6.306 8.1h-42.045l6.307-10.414-24.176 3.471 9.46-12.73-37.431 52.566s-21.432-59.509 9.05-76.867z"
        fill="#2f2e41"
      />
      <circle cx={684.398} cy={383.545} r={100} fill="#3f3d56" />
      <circle cx={684.398} cy={383.545} r={86} opacity={0.1} />
      <path
        d="M680.277 434.293v-12.517c-6.328-.124-12.873-2.355-16.691-5.453l2.618-8.303a26.681 26.681 0 0015.71 5.328c7.745 0 12.981-5.08 12.981-12.145 0-6.816-4.254-11.03-12.327-14.748-11.128-4.957-18-10.658-18-21.44 0-10.286 6.436-18.094 16.473-19.953v-12.517h6.763v12.022a26.543 26.543 0 0114.182 4.337l-2.727 8.18a24.107 24.107 0 00-13.746-4.214c-8.4 0-11.564 5.7-11.564 10.658 0 6.444 4.037 9.666 13.528 14.128 11.236 5.205 16.91 11.65 16.91 22.68 0 9.79-6 18.961-17.237 21.067v12.89z"
        fill="#3f51b5"
      />
      <path opacity={0.2} d="M250.005 504.87L290 629.803l-32-130-7.995 5.067z" />
      <path
        d="M46.093 260.803H20.707a4.178 4.178 0 01-4.174-4.173v-36.493a4.178 4.178 0 014.174-4.174h25.386a4.178 4.178 0 014.174 4.174v36.493a4.178 4.178 0 01-4.174 4.173zm-25.386-42.84a2.176 2.176 0 00-2.174 2.174v36.493a2.176 2.176 0 002.174 2.173h25.386a2.176 2.176 0 002.174-2.173v-36.493a2.176 2.176 0 00-2.174-2.174zM92.463 260.803H69.537a5.41 5.41 0 01-5.404-5.404V181.7a5.41 5.41 0 015.404-5.404h22.926a5.41 5.41 0 015.404 5.404v73.7a5.41 5.41 0 01-5.404 5.403zm-22.926-82.507a3.408 3.408 0 00-3.404 3.404v73.7a3.408 3.408 0 003.404 3.403h22.926a3.408 3.408 0 003.404-3.404V181.7a3.408 3.408 0 00-3.404-3.404zM139.178 260.803h-21.156a6.296 6.296 0 01-6.289-6.289V146.092a6.296 6.296 0 016.29-6.289h21.155a6.296 6.296 0 016.289 6.29v108.421a6.296 6.296 0 01-6.29 6.29zm-21.156-119a4.294 4.294 0 00-4.289 4.29v108.421a4.294 4.294 0 004.29 4.29h21.155a4.294 4.294 0 004.289-4.29V146.092a4.294 4.294 0 00-4.29-4.289z"
        fill="#3f3d56"
      />
      <path
        fill="#3f51b5"
        d="M23.88 222.913h19.04v30.94H23.88zM71.48 183.643h19.04v70.21H71.48zM119.08 147.15h19.04v106.703h-19.04z"
      />
      <path
        d="M723 145.803H590a1 1 0 01-1-1v-135a1 1 0 012 0v134h132a1 1 0 010 2zM159 274.803H1a1 1 0 01-1-1v-157a1 1 0 012 0v156h157a1 1 0 010 2z"
        fill="#3f3d56"
      />
      <path
        d="M635.898 133.27h-25.386a4.178 4.178 0 01-4.174-4.173V92.604a4.178 4.178 0 014.174-4.173h25.386a4.178 4.178 0 014.173 4.173v36.493a4.178 4.178 0 01-4.173 4.174zm-25.386-42.84a2.176 2.176 0 00-2.174 2.174v36.493a2.176 2.176 0 002.174 2.174h25.386a2.176 2.176 0 002.173-2.174V92.604a2.176 2.176 0 00-2.173-2.173zM687.888 133.27H664.52a5.19 5.19 0 01-5.183-5.184v-66.1a5.19 5.19 0 015.183-5.183h23.367a5.19 5.19 0 015.183 5.184v66.1a5.19 5.19 0 01-5.183 5.184zM664.52 58.804a3.187 3.187 0 00-3.183 3.184v66.1a3.187 3.187 0 003.183 3.184h23.367a3.187 3.187 0 003.183-3.185v-66.1a3.187 3.187 0 00-3.183-3.183z"
        fill="#3f3d56"
      />
      <path
        fill="#3f51b5"
        d="M613.228 95.727h19.04v30.94h-19.04zM666.685 65.105h19.04v59.864h-19.04z"
      />
      <circle cx={623} cy={68.803} r={9} fill="#3f51b5" />
      <circle cx={676} cy={34.803} r={9} fill="#3f51b5" />
    </svg>
  );
}

export default SvgUndrawPersonalFinanceTqcd;
